module.exports = __webpack_public_path__ + "img/award.5a7088ff.jpg";